





















































import Vue from "vue";

import {
  propsDefHasSpeakerIcon,
  propsDefIsCorrect
} from "../../constants/chat";
import {
  PropsHasSpeakerIcon,
  PropsIsCorrect,
  PropsIsChatMessage
} from "../../models/chat";

interface Props
  extends PropsHasSpeakerIcon,
    PropsIsCorrect,
    PropsIsChatMessage {
  hasAlternateBg: boolean;
  /**
   * Remove padding from msg body AND header. Default to false
   */
  noPadding: boolean;
  /**
   * Adding specific styling for clicking action
   */
  isClickable: boolean;
}

export default Vue.extend<Props>({
  name: "JzChatMsg",
  functional: true,
  props: {
    ...propsDefHasSpeakerIcon,
    ...propsDefIsCorrect,
    avatarUrl: { type: String, default: undefined },
    hasAlternateBg: { type: Boolean, default: false },
    noPadding: { type: Boolean, default: false },
    type: {
      type: String,
      required: true,
      validator: (val: string) => ["user", "bot"].includes(val)
    },
    isClickable: { type: Boolean, default: false }
  }
});
